export default __webpack_public_path__ + "static/media/btn-skip-off.55cab894.png";